module.exports = __webpack_public_path__ + "img/install_white_middle.b96b41b6.png";